import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepOne = _resolveComponent("StepOne")
  const _component_StepTwo = _resolveComponent("StepTwo")
  const _component_StepThree = _resolveComponent("StepThree")
  const _component_StepFour = _resolveComponent("StepFour")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary importExportDialog",
    style: _ctx.dataViewDescriptor.style.dialog,
    visible: _ctx.visible,
    footer: "footer",
    header: _ctx.$t('workspace.myData.wizardTitle'),
    closable: false,
    modal: ""
  }, {
    footer: _withCtx(() => [
      _createVNode("div", null, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--secondary",
          label: _ctx.$t('common.cancel'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeDialog')))
        }, null, 8, ["label"]),
        (_ctx.wizardStep > 1)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "kn-button kn-button--secondary",
              label: _ctx.$t('common.back'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.wizardStep--))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          label: _ctx.$t('common.next'),
          disabled: !_ctx.fileUploaded,
          onClick: _ctx.documentFields
        }, null, 8, ["label", "disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.wizardStep === 1)
        ? (_openBlock(), _createBlock("span", _hoisted_1, [
            _createVNode(_component_StepOne, {
              selectedDataset: _ctx.dataset,
              onFileUploaded: _ctx.onFileUpload
            }, null, 8, ["selectedDataset", "onFileUploaded"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.wizardStep === 2)
        ? (_openBlock(), _createBlock("span", _hoisted_2, [
            _createVNode(_component_StepTwo, { selectedDataset: _ctx.dataset }, null, 8, ["selectedDataset"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.wizardStep === 3)
        ? (_openBlock(), _createBlock("span", _hoisted_3, [
            _createVNode(_component_StepThree, { gridForPreview: _ctx.gridForPreview }, null, 8, ["gridForPreview"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.wizardStep === 4)
        ? (_openBlock(), _createBlock("span", _hoisted_4, [
            _createVNode(_component_StepFour, { selectedDataset: _ctx.dataset }, null, 8, ["selectedDataset"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style", "visible", "header"]))
}